import { z } from 'zod';

const FieldsSchema = z.object({
  adserverCost: z.string().optional(),
  budget: z.nullable(z.string()).optional(),
  calculatedClicks: z.nullable(z.string()).optional(),
  calculatedConversions: z.nullable(z.string()).optional(),
  calculatedImpressions: z.nullable(z.string()).optional(),
  calculatedLeads: z.nullable(z.string()).optional(),
  calculatedVideoViews: z.nullable(z.string()).optional(),
  compoundBudget: z.nullable(z.string()).optional(),
  cr: z.nullable(z.string()).optional(),
  ctr: z.nullable(z.string()).optional(),
  dateFrom: z.nullable(z.string()).optional(),
  dateTo: z.nullable(z.string()).optional(),
  dspCost: z.nullable(z.string()).optional(),
  vtr: z.nullable(z.string()).optional(),
});

const CampaignSchema = z.object({
  id: z.number(),
  campaign: z.nullable(z.number()),
  isConfigured: z.boolean(),
  platformMedia: z.string(),
  channel: z.string(),
  label: z.string(),
});

const PlatformSchema = z.object({
  name: z.string(),
  label: z.string(),
  id: z.number(),
  fields: FieldsSchema,
  isGhost: z.boolean(),
  subItems: z.array(CampaignSchema).optional(),
});

const VersionItemSchema = z.object({
  name: z.string(),
  label: z.string(),
  fields: FieldsSchema,
  isGhost: z.boolean().optional(),
  subItems: z.array(PlatformSchema).optional(),
});

export const VersionForTableViewSchema = z.object({
  id: z.number(),
  name: z.string(),
  items: z.array(VersionItemSchema),
  isCurrent: z.boolean().optional(),
});
